import classNames from 'classnames';
import useIsMobileDevice from 'hooks/UseIsMobileDevice';
import React, { ReactNode } from 'react';

interface Props {
  className?: string;
  children: ReactNode;
}

export default function FormFieldDescription({ children, className }: Props): JSX.Element {
  const isMobileDevice = useIsMobileDevice();

  return (
    <p
      className={classNames('text-gray-500 text-sm mb-2', className, {
        'text-xs': !isMobileDevice,
        'text-sm': isMobileDevice,
      })}
    >
      {children}
    </p>
  );
}
